import React from 'react'

import {
  AlignItems,
  Box,
  Display,
  FlexDirection,
  JustifyContent,
} from '@gousto-internal/citrus-react'

import { ComparisonTable } from 'routes/Home/PriceComparisonTable/components/ComparisonTable/ComparisonTable'
import { WelcomeSection } from 'routes/Home/PriceComparisonTable/components/WelcomeSection/WelcomeSection'
import { TABLE_DATA, BLOCK_WIDTH_LIST } from 'routes/Home/PriceComparisonTable/constants'

import { CTAContainer } from './components/CTAContainer/CTAContainer'

export function PriceComparisonTable() {
  return (
    <Box display={Display.Flex} justifyContent={JustifyContent.Center}>
      <Box
        data-testid="PriceComparisonTable"
        display={Display.Flex}
        flexDirection={[FlexDirection.Column, null, FlexDirection.Row]}
        justifyContent={JustifyContent.Center}
        alignItems={AlignItems.Center}
        maxWidth="1200px"
        paddingV={10}
        paddingBottom={6}
        paddingH={8}
        gap={8}
      >
        <Box
          width={BLOCK_WIDTH_LIST}
          display={Display.Flex}
          flexDirection={FlexDirection.Column}
          alignItems={[AlignItems.Center, null, AlignItems.FlexStart]}
        >
          <WelcomeSection />
          <CTAContainer screenSize="large" />
        </Box>
        <ComparisonTable items={TABLE_DATA} />
        <CTAContainer screenSize="smallAndMedium" />
      </Box>
    </Box>
  )
}
